import React from 'react'

import { Heading, Paragraph } from '../../components/typography'
import { Domain } from './Domain'

const mainTraffic = {
  ticker: 'AAPL',
  domain: 'apple.com',
  sector: 'Information Technology',
  industryGroup: 'Technology Hardware & Equipment',
  industry: 'Electronic Equipment, Instruments & Components',
  heatmapSector: 'Retail & Ecommerce',
  heatmapSubSector: 'Electronics Retail',
  peers: 'bestbuy.com bhphotovideo.com dell.com newegg.com gopro.com',
  traffic: {
    d: [202309, 202310, 202311, 202312, 202401, 202402, 202403, 202404, 202405, 202406, 202407, 202408],
    v: [
      540748750, 505229547, 487297621, 488173477, 491135108, 455089483, 469888439, 438799320, 466652151, 447602427,
      460280112, 466004425,
    ],
  },
}

const peerTraffics = [
  {
    ticker: null,
    domain: 'bhphotovideo.com',
    heatmapSector: 'Retail & Ecommerce',
    heatmapSubSector: 'Electronics Retail',
    peers: 'adorama.com bestbuy.com newegg.com crutchfield.com apple.com',
    traffic: {
      d: [202309, 202310, 202311, 202312, 202401, 202402, 202403, 202404, 202405, 202406, 202407, 202408],
      v: [
        16882382, 15587001, 19360737, 17491439, 15626709, 14937833, 15778420, 14048463, 14447505, 13713870, 14458610,
        13244665,
      ],
    },
  },
  {
    ticker: 'NEGG',
    domain: 'newegg.com',
    sector: 'Consumer Discretionary',
    industryGroup: 'Automobiles & Components',
    industry: 'Automobiles',
    heatmapSector: 'Retail & Ecommerce',
    heatmapSubSector: 'Electronics Retail',
    peers: 'bestbuy.com bhphotovideo.com microcenter.com monoprice.com adorama.com',
    traffic: {
      d: [202309, 202310, 202311, 202312, 202401, 202402, 202403, 202404, 202405, 202406, 202407, 202408],
      v: [
        14655543, 14675084, 21299681, 17083935, 14989483, 12606841, 12744555, 11189424, 11204263, 10793083, 12361144,
        10800396,
      ],
    },
  },
  {
    ticker: 'BBY',
    domain: 'bestbuy.com',
    sector: 'Consumer Discretionary',
    industryGroup: 'Retailing',
    industry: 'Specialty Retail',
    heatmapSector: 'Retail & Ecommerce',
    heatmapSubSector: 'Electronics Retail',
    peers: 'bhphotovideo.com newegg.com microcenter.com adorama.com crutchfield.com',
    traffic: {
      d: [202309, 202310, 202311, 202312, 202401, 202402, 202403, 202404, 202405, 202406, 202407, 202408],
      v: [
        103083547, 109511672, 183001509, 145494317, 106208296, 91989808, 89471329, 82107190, 93211500, 95630411,
        107767846, 108331167,
      ],
    },
  },
  {
    ticker: 'GPRO',
    domain: 'gopro.com',
    sector: 'Information Technology',
    industryGroup: 'Technology Hardware & Equipment',
    industry: 'Electronic Equipment, Instruments & Components',
    heatmapSector: 'Retail & Ecommerce',
    heatmapSubSector: 'Electronics Retail',
    peers: 'adorama.com bhphotovideo.com crutchfield.com bestbuy.com newegg.com',
    traffic: {
      d: [202309, 202310, 202311, 202312, 202401, 202402, 202403, 202404, 202405, 202406, 202407, 202408],
      v: [6691953, 5650591, 5848752, 5772722, 5387842, 4922998, 5067003, 4727655, 4848193, 5098999, 5130140, 4867626],
    },
  },
  {
    ticker: 'DELL',
    domain: 'dell.com',
    sector: 'Information Technology',
    industryGroup: 'Technology Hardware & Equipment',
    industry: 'Technology Hardware, Storage & Peripherals',
    heatmapSector: 'Retail & Ecommerce',
    heatmapSubSector: 'Electronics Retail',
    peers: 'bestbuy.com newegg.com bhphotovideo.com microcenter.com kabum.com.br',
    traffic: {
      d: [202309, 202310, 202311, 202312, 202401, 202402, 202403, 202404, 202405, 202406, 202407, 202408],
      v: [
        45350663, 46275790, 54923594, 43819278, 47816519, 41098872, 45505450, 40775151, 40332786, 39203811, 45198644,
        41075116,
      ],
    },
  },
]

interface Props {
  companyName: string
}

export function NoDataPlaceholder({ companyName }: Props) {
  return (
    <div className="is-js-module relative">
      <div className="pointer-events-none blur-xs">
        <Domain
          mainTraffic={mainTraffic}
          peerTraffics={peerTraffics}
          industryTraffics={peerTraffics}
          isInView
          hasBeenInView
        />
      </div>
      <div className="absolute inset-0 flex items-center justify-center bg-white/10 dark:bg-gray-800/10">
        <div className="flex max-w-lg flex-col bg-white p-6 dark:bg-gray-800">
          <Heading level={4}>Data Unavailable for {companyName}</Heading>
          <Paragraph>
            Currently, we do not have sufficient data to display the{' '}
            <strong>associated domains and smartphone apps for this company</strong>. As soon as the relevant
            information becomes available, this view will be updated to provide you with valuable insights.
          </Paragraph>
        </div>
      </div>
    </div>
  )
}
